module.exports = __webpack_public_path__ + "static/media/Steve Vancore Headshot_1702401712455.f398ca42.png";